import React from 'react';

import { NotFound } from '@hero/organisms';

import RootLayout from '../layout';

export default function NotFoundPage() {
  return (
    <RootLayout>
      <NotFound />
    </RootLayout>
  );
}
